import PropTypes from "prop-types";
import React, { Fragment } from "react";

import { isFailure, IN_PROGRESS } from "commons/src/helpers/RequestHelpers";

import { ERROR } from "../../helpers/ErrorHelpers";
import { requestObject } from "../../reducers/requestsActions";
import { WrapperContributions } from "./WrapperContributions";
import { WrapperIncome } from "./WrapperIncome";
import { Message } from "../../components/Message";

export function WrapperDetails({
    hasMultipleISAs,
    hasMultiplePensions,
    accountDetails,
    requestStatus,
    isISA,
    isPension,
    isDrawdown
}) {
    const hasMultiple = () => {
        if (isISA) {
            return hasMultipleISAs;
        } else if (isPension) {
            return hasMultiplePensions;
        }
    };

    return isFailure(requestStatus.status) ? (
        <Message
            severity={ERROR}
            text={requestStatus.errorMessage}
            errorCode={requestStatus.errorCode}
        />
    ) : (
        <Fragment>
            {((isPension || isISA) && (
                <WrapperContributions
                    hasMultiple={hasMultiple()}
                    wrapperDetails={accountDetails.wrapperDetails}
                    isPension={isPension}
                />
            )) ||
                (isDrawdown && (
                    <WrapperIncome
                        accountNumber={accountDetails.accountNumber}
                        wrapperDetails={accountDetails.wrapperDetails}
                    />
                ))}
        </Fragment>
    );
}

WrapperDetails.defaultProps = {
    requestStatus: {
        status: IN_PROGRESS
    }
};

WrapperDetails.propTypes = {
    accountDetails: PropTypes.object,
    accountType: PropTypes.string,
    hasMultipleISAs: PropTypes.bool,
    hasMultiplePensions: PropTypes.bool,
    isISA: PropTypes.bool,
    isDrawdown: PropTypes.bool,
    isPension: PropTypes.bool,
    requestStatus: requestObject
};
